import { WatchlistError } from '~/stores/use-watchlist/watchlist-types';

interface HandleReOrderListProps<T> {
  toIdx: number;
  fromIdx: number;
  list: T[];
}

export const handleReOrderList = <T>({
  list,
  toIdx,
  fromIdx,
}: HandleReOrderListProps<T>) => {
  const newList = [...list];
  const tempElement = newList[fromIdx];
  newList.splice(fromIdx, 1);
  newList.splice(toIdx, 0, tempElement);

  return newList;
};

interface ValidateListCreationProps {
  isAddMode: boolean;
  listName: string;
  rowSelection: Record<string, boolean>;
  unMappedEntitiesList: { input: string }[];
}

interface ValidationResult {
  isValid: boolean;
  tags: string[];
  unresolvedTags: string[];
  error?: WatchlistError;
}

export const validateListCreation = ({
  isAddMode,
  listName,
  rowSelection,
  unMappedEntitiesList,
}: ValidateListCreationProps): ValidationResult => {
  if (!isAddMode && !listName) {
    return {
      isValid: false,
      tags: [],
      unresolvedTags: [],
      error: WatchlistError.EmptyName,
    };
  }

  const tags = Object.keys(rowSelection).filter(tag => rowSelection[tag]);

  if (!isAddMode && !tags.length) {
    return {
      isValid: false,
      tags: [],
      unresolvedTags: [],
      error: WatchlistError.EmptyList,
    };
  }

  return {
    isValid: true,
    tags,
    unresolvedTags: unMappedEntitiesList.map(e => e.input),
  };
};
